import { Controller } from '@hotwired/stimulus';

import ReturnGraphController from './returns-graph-controller';

export default class extends Controller {
  connect() {
    this.connectInputListener();
  }

  disconnect() {
    this.disconnectInputListener();
  }

  connectInputListener() {
    // @ts-expect-error TS2531 violates strict null checks
    this.tabNavCardTarget.addEventListener(
      'change',
      this.redrawGraphs.bind(this) as EventListenerOrEventListenerObject
    );
  }

  disconnectInputListener() {
    // @ts-expect-error TS2531 violates strict null checks
    this.tabNavCardTarget.removeEventListener('change', this.redrawGraphs.bind(this));
  }

  redrawGraphs() {
    this.returnsGraphController.draw();
  }

  setValid(valid) {
    if (valid) {
      this.element.classList.remove('invalid');
    } else {
      this.element.classList.add('invalid');
    }
  }

  get tabNavCardTarget() {
    return this.element.querySelector('.sc-TabNavCard');
  }

  get tabNavController() {
    // @ts-expect-error TS2345 violates strict null checks
    return this.application.getControllerForElementAndIdentifier(this.tabNavCardTarget, 'tab-nav-card');
  }

  get returnsGraphTarget() {
    return this.element.querySelector(
      '.SelfDirectedAllocationSelection-returnsProjectionComponent [data-controller="returns-graph"]'
    );
  }

  get returnsGraphController() {
    return this.application.getControllerForElementAndIdentifier(
      // @ts-expect-error TS2345 violates strict null checks
      this.returnsGraphTarget,
      'returns-graph'
    ) as ReturnGraphController;
  }
}
